import { createContext, useContext, type ReactNode } from 'react';
import { useWallet, type WalletState } from './useWallet';

type WalletContextValue = WalletState & {
  connect: () => Promise<void>;
  disconnect: () => Promise<void>;
};

const WalletContext = createContext<WalletContextValue | null>(null);

export function WalletProvider({ children }: { children: ReactNode }) {
  const wallet = useWallet();
  return <WalletContext.Provider value={wallet}>{children}</WalletContext.Provider>;
}

export function useWalletContext(): WalletContextValue {
  const value = useContext(WalletContext);
  if (!value) throw new Error('useWalletContext used outside WalletProvider');
  return value;
}

export function useVerifiedAddress(): string | null {
  const wallet = useWalletContext();
  return wallet.status === 'ready' ? wallet.wallet.address : null;
}
